import React from 'react';
import { Box, Tabs, Tab, Chip } from '@mui/material';
import { Article, Preview, QuestionAnswer } from '@mui/icons-material';

interface ModalTabsProps {
  activeTab: number;
  onTabChange: (event: React.SyntheticEvent, newValue: number) => void;
  isStreamingActive: boolean;
  showChatTab?: boolean;
}

export const ModalTabs: React.FC<ModalTabsProps> = ({ 
  activeTab, 
  onTabChange, 
  isStreamingActive,
  showChatTab = false
}) => {
  return (
    <Box sx={{ borderBottom: '1px solid #e5e7eb', bgcolor: 'white' }}>
      <Tabs
        value={activeTab}
        onChange={onTabChange}
        sx={{
          minHeight: 48,
          '& .MuiTab-root': {
            minHeight: 48,
            textTransform: 'none',
            fontWeight: 500,
            fontSize: '0.875rem'
          }
        }}
      >
        <Tab
          label="Processing Steps"
          icon={<Article sx={{ fontSize: '1.125rem' }} />}
          iconPosition="start"
          sx={{ gap: 1 }}
        />
        <Tab
          label={
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              Document Preview
              {isStreamingActive && (
                <Chip
                  label="Live"
                  size="small"
                  sx={{
                    backgroundColor: '#dcfce7',
                    color: '#166534',
                    fontWeight: 500,
                    fontSize: '0.65rem',
                    height: 18,
                    border: '1px solid #bbf7d0'
                  }}
                />
              )}
            </Box>
          }
          icon={<Preview sx={{ fontSize: '1.125rem' }} />}
          iconPosition="start"
          sx={{ gap: 1 }}
        />
        {showChatTab && (
          <Tab
            label="Document Chat"
            icon={<QuestionAnswer sx={{ fontSize: '1.125rem' }} />}
            iconPosition="start"
            sx={{ gap: 1 }}
          />
        )}
      </Tabs>
    </Box>
  );
}; 
